import type { Components, Theme } from '@mui/material/styles';

export function navigationOverrides(theme: Theme): Components<Theme> {
  const mobile = theme.breakpoints.down('sm');

  return {
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          minHeight: 40,
          minWidth: 0,
          paddingInline: theme.spacing(3),
          [mobile]: { minHeight: 44 },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: { height: 2, backgroundColor: theme.palette.primary.main },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          [mobile]: { minHeight: 48 },
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          borderRadius: 4,
          boxShadow: '0 4px 12px rgba(0,0,0,0.4)',
          border: `1px solid ${theme.palette.divider}`,
          backgroundImage: 'none',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          minHeight: 32,
          fontSize: '0.8125rem',
          [mobile]: { minHeight: 48 },
        },
      },
    },
    MuiBottomNavigation: {
      styleOverrides: {
        root: { height: 56, backgroundColor: theme.palette.background.paper },
      },
    },
    MuiBottomNavigationAction: {
      styleOverrides: {
        root: { minWidth: 0, minHeight: 44, padding: theme.spacing(1), color: theme.palette.text.secondary },
        label: {
          fontSize: '0.6875rem',
          lineHeight: 1.2,
          '&.Mui-selected': { fontSize: '0.6875rem' },
        },
      },
    },
    MuiLink: { defaultProps: { underline: 'hover' } },
    MuiTooltip: {
      defaultProps: { arrow: false, enterDelay: 400 },
      styleOverrides: {
        tooltip: {
          backgroundColor: theme.palette.background.elevated,
          color: theme.palette.text.primary,
          border: `1px solid ${theme.palette.divider}`,
          fontSize: '0.75rem',
          borderRadius: 4,
          padding: theme.spacing(1, 2),
          boxShadow: '0 4px 12px rgba(0,0,0,0.4)',
        },
      },
    },
  };
}
